import React from 'react';

export const Home = () => {
  return (
    <main>
      {/* Hero Section */}
      <section className="relative h-screen">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://uploads.lebonbon.fr/source/2023/lille/Pano-JdP_news_image_top.jpg')`
          }}
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div>
            <img src="/images/logo_détouré.png" alt="Logo" className="w-64 h-auto mb-8" />
            <h1 className="text-6xl md:text-7xl font-bold font-fredoka mb-6">
              <span className="text-white">
                La Mine des Mines
              </span>
            </h1>
            <p className="text-2xl md:text-3xl text-white mb-8 max-w-2xl font-fredoka">
            La meilleure des préparations aux oraux : c'est le repos (et une bonne caisse) ! <br></br>

            </p>
            <div className="space-x-4">
              <a
                href="/store"
                className="inline-block bg-mdm-pink text-white px-8 py-4 rounded-lg text-lg font-fredoka font-semibold hover:bg-mdm-blue transform hover:scale-105 transition-all"
              >
                Voir le store (et le merch de fou malade)
              </a>
              <a
                href="#details"
                className="inline-block bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-fredoka font-semibold hover:bg-white/20 transform hover:scale-105 transition-all"
              >
                Découvrir la mine des mines
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Event Details Section */}
      <section id="details" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold font-fredoka text-mdm-pink mb-6">
                La fin des concours
              </h2>
              <p className="text-lg text-gray-700 mb-6 font-fredoka">
                La mine des mines revient plus forte que jamais, avec encore plus de bonne musique, encore plus de bidons, encore plus de traditions et, on l'espère, encore plus de monde !
              </p>
              <ul className="space-y-4 font-fredoka">
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-mdm-pink rounded-full mr-3"></span>
                  Date : 15 Mai 2025
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-mdm-blue rounded-full mr-3"></span>
                  Lieu : Jardin des Plantes, Lille
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-mdm-yellow rounded-full mr-3"></span>
                  Horaires : 19h - 00h
                </li>
              </ul>
            </div>
            <div className="relative">
              <img
                src="/images/logo.png"
                alt="Ambiance festive"
                className="rounded-lg shadow-xl"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-mdm-pink/20 to-mdm-blue/20 rounded-lg"></div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}; 